import { render, staticRenderFns } from "./addressdetail.vue?vue&type=template&id=18692b6d&scoped=true&"
import script from "./addressdetail.vue?vue&type=script&lang=js&"
export * from "./addressdetail.vue?vue&type=script&lang=js&"
import style0 from "./addressdetail.vue?vue&type=style&index=0&id=18692b6d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18692b6d",
  null
  
)

export default component.exports